<div *ngIf="foreignPhoneResidents.length" class="flex-row v-center foreground yellow-darker margin-bottom-10">
  <mat-icon class="margin-right-5">warning</mat-icon>
  <span>
    {{ 'select.foreignPhoneNumbersUnavailable' | locRep: { $count: foreignPhoneResidents.length } }}
    {{ foreignPhoneResidentsPreview }}
  </span>
</div>
<div *ngIf="invalidPhoneResidents.length" class="flex-row v-center foreground yellow-darker margin-bottom-10">
  <mat-icon class="margin-right-5">warning</mat-icon>
  <span>
    {{ 'select.invalidPhoneNumbersUnavailable' | locRep: { $count: invalidPhoneResidents.length } }}
    {{ invalidPhoneResidentsPreview }}
  </span>
</div>
<div *ngIf="selectedResidents?.length" class="margin-bottom-10">
  <div>{{ 'label.selectedResidents' | locRep: { $value: selectedCount } }}</div>
  <div class="table">
    <div class="row header white">
      <div>{{ 'user.nameSurname' | locCap }}</div>
      <div>{{ 'label.' + displayMode | locCap }}</div>
      <div>{{ 'label.address' | loc }}</div>
    </div>
  </div>
  <div class="scrollable-table table">
    <ng-container *ngFor="let data of selectedResidents">
      <div class="row white">
        <div>{{ data.resident | fullName }}</div>
        <div *ngIf="displayMode === 'email'">{{ data.resident | getEmail }}</div>
        <div *ngIf="displayMode === 'phone'">{{ data.resident | getPhone }}</div>
        <div>
          <span *ngFor="let adr of addressIcons(data.units); let last = last">
            <mat-icon inline>{{ adr.icon }}</mat-icon> {{ adr.number }}<ng-container *ngIf="!last">, </ng-container>
          </span>
        </div>
      </div>
    </ng-container>
  </div>
</div>
<div *ngIf="!selectedResidents" class="margin-bottom-5">{{ residentsPreview | capitalize }} ({{ selectedCount }})</div>
<button mat-stroked-button class="mat-primary" (click)="showDialog()">
  {{ 'button.selectReceivers' | loc }}
</button>
<mat-error *ngIf="touched && !selectedResidents?.length && !selectedCount">{{ 'error.noReceivers' | loc }}</mat-error>
